import React from 'react';
export const RoutingContext = React.createContext({
    lessonUrl: (lesson) => lesson.course != null ? `/kurzusok/${lesson.course.id}/${lesson.id}` : `/leckek/${lesson.id}`,
    coursesUrl: () => '/kurzusok',
    courseUrl: (course) => `/kurzusok/${course.id}`
});
//# sourceMappingURL=RoutingContext.js.map